module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/17r3IuK/images/cover.jpg?1684515573050",
      "alt": "This image is the cover for the book Haunted Heart"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Haunted Heart\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Duncan Kerr is the art director of Enamored Press, an erotic romance publisher based in Seattle. An open submissions call for new artists yields an imaginative book cover with rich details and bold colors that catches his interest. After a few more samples of work and some e-mails, Duncan is determined to hire the talented young artist on a permanent basis.")]), _vm._v(" "), _c('p', [_vm._v("But Ruben Winterbottom isn’t an average freelance artist. His agoraphobia leaves him terrified to set foot outside his secluded house in the woods by the Olympic National Park. Living alone, fear is Ruben’s sole companion.")]), _vm._v(" "), _c('p', [_vm._v("When the two men meet, Ruben has a panic attack and hides away. Although confused, Duncan sees past Ruben’s anxiety to his artistic gifts and beautiful soul. So he sets out to coax the young man out of his shy shell.")]), _vm._v(" "), _c('p', [_vm._v("Falling in love with a broken boy, however, might be the first draft of heartbreak.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Susan Laine\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0